import { render, staticRenderFns } from "./penjualanfrm.vue?vue&type=template&id=5c438280"
import script from "./penjualanfrm.vue?vue&type=script&lang=js"
export * from "./penjualanfrm.vue?vue&type=script&lang=js"
import style0 from "./penjualanfrm.vue?vue&type=style&index=0&id=5c438280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports